export function playerTag(row: { player_position?: string | null; team_short?: string | null }): string | null {
  const parts = [row.player_position, row.team_short].filter((part): part is string => !!part);
  return parts.length === 0 ? null : parts.join(" · ");
}
